import { Controller } from "@hotwired/stimulus";

export default class NotEnoughBalanceController extends Controller {
  connect() {
    this.hideLoadingScreen();
  }

  showLoadingScreen() {
    this.dispatch("showLoadingScreen", { detail: { text: "Please Wait" } });
  }

  hideLoadingScreen() {
    this.dispatch("hideLoadingScreen");
  }
}
